import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      '&&': {
        padding: theme.spacing(10, 'auto'),
      },
    },
  })
);

export default useStyles;
